<!-- ============ SPLASH SCREEN ============ -->
<div class="global-splash-screen" *ngIf="!kossayaService.isInitialized">
    <div class="splash-content">
        <img src="assets/images/kossaya/logo_putih.png" alt="Kos Saya" class="splash-logo" />
        <div class="splash-spinner"></div>
    </div>
</div>

<!-- ============ HEADER ============ -->
<header class="app-header">
    <!-- Left: hamburger (mobile) + logo -->
    <div class="header-left">
        <button class="hamburger" (click)="toggleSidebar()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
        </button>
        <img src="assets/images/kossaya/logo_putih.png" alt="Kos Saya" class="header-logo" />
    </div>

    <!-- Right: User info + datetime -->
    <div class="header-right">

        <div class="user-info">
            <span class="user-name">{{ currentUser?.name || 'User' }}</span>
            <span class="user-role">{{ currentUser?.role || 'User' }}</span>
        </div>
        <div class="user-avatar-wrapper">
            <img src="assets/images/kossaya/bimbul_face_recognition.png" alt="Profile" class="avatar-img"
                (click)="toggleProfileMenu()" />
            <!-- Profile dropdown (desktop) -->
            <div class="profile-dropdown" *ngIf="profileMenuOpen">
                <div class="profile-dropdown-header">
                    <span class="dropdown-name">{{ currentUser?.name || 'User' }}</span>
                    <span class="dropdown-role">{{ currentUser?.role || 'User' }}</span>
                </div>
                <div class="profile-dropdown-divider"></div>
                <a class="profile-dropdown-item" (click)="navigateTo('/profile'); profileMenuOpen = false;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    <span>Manage Profil</span>
                </a>
                <a class="profile-dropdown-item logout-item" (click)="logout()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                    <span>Keluar</span>
                </a>
            </div>
        </div>
        <div class="header-datetime">
            <span class="day">{{ currentDay }}</span>
            <span class="date">{{ currentDate }}</span>
            <span class="time">{{ currentTime }}</span>
        </div>
    </div>
</header>

<div class="app-body">
    <!-- ============ SIDEBAR ============ -->
    <aside class="app-sidebar" [class.open]="sidebarOpen" [class.collapsed]="sidebarCollapsed">

        <!-- Mobile: User profile header -->
        <div class="sidebar-profile">
            <button class="sidebar-close" (click)="toggleSidebar()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
            <div class="sidebar-profile-info" (click)="navigateTo('/profile')">
                <img src="assets/images/kossaya/bimbul_face_recognition.png" alt="Profile" class="sidebar-avatar" />
                <div class="sidebar-profile-text">
                    <span class="sidebar-user-name">{{ currentUser?.name || 'User' }}</span>
                    <span class="sidebar-user-role">{{ currentUser?.role || 'User' }}</span>
                </div>
            </div>
        </div>

        <nav class="sidebar-nav">
            <ng-container *ngFor="let item of visibleMenuItems">
                <div class="menu-group">
                <a class="nav-item" [class.active]="isActive(item)" [class.expanded]="item.expanded"
                    (click)="navigateTo(item)">
                    <span class="nav-icon-center">
                    <img *ngIf="!item.useSvg" class="nav-icon-img"
                        [src]="isActive(item) ? item.iconSelected : item.icon" [alt]="item.label" />
                    <!-- Booking icon -->
                    <svg *ngIf="item.useSvg && item.svgType === 'booking'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="nav-icon-svg">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                        <path d="M8 14h.01"></path>
                        <path d="M12 14h.01"></path>
                        <path d="M16 14h.01"></path>
                        <path d="M8 18h.01"></path>
                        <path d="M12 18h.01"></path>
                        <path d="M16 18h.01"></path>
                    </svg>
                    <!-- Settings gear icon -->
                    <svg *ngIf="item.useSvg && (!item.svgType || item.svgType === 'settings')"
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="nav-icon-svg">
                        <circle cx="12" cy="12" r="3"></circle>
                        <path
                            d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z">
                        </path>
                    </svg>
                    <!-- Pelanggaran icon -->
                    <svg *ngIf="item.useSvg && item.svgType === 'pelanggaran'" xmlns="http://www.w3.org/2000/svg"
                        width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="nav-icon-svg">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                    <!-- Pengaduan icon -->
                    <svg *ngIf="item.useSvg && item.svgType === 'pengaduan'" xmlns="http://www.w3.org/2000/svg"
                        width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="nav-icon-svg">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                    <!-- Iklan icon -->
                    <svg *ngIf="item.useSvg && item.svgType === 'iklan'" xmlns="http://www.w3.org/2000/svg" width="24"
                        height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="nav-icon-svg">
                        <path
                            d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z">
                        </path>
                    </svg>
                    <!-- Fasilitas Umum icon (from assets/images/kossaya/fasilitas_ico.svg path) -->
                    <svg *ngIf="item.useSvg && item.svgType === 'fasilitas-umum'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" class="nav-icon-svg">
                        <rect x="8" y="16" width="48" height="42" rx="3" stroke="currentColor" stroke-width="4" fill="none"/>
                        <path d="M4 18 L32 4 L60 18" class="svg-yellow-stroke" stroke-width="4" fill="none"/>
                        <path d="M25 28 Q32 22 39 28" class="svg-yellow-stroke" stroke-width="3" fill="none"/>
                        <path d="M28 32 Q32 28 36 32" class="svg-yellow-stroke" stroke-width="3" fill="none"/>
                        <circle cx="32" cy="35" r="2.5" class="svg-yellow-fill" fill="currentColor"/>
                        <line x1="20" y1="48" x2="44" y2="48" stroke="currentColor" stroke-width="3"/>
                        <rect x="17" y="44" width="6" height="8" rx="1.5" class="svg-yellow-fill" fill="currentColor"/>
                        <rect x="41" y="44" width="6" height="8" rx="1.5" class="svg-yellow-fill" fill="currentColor"/>
                    </svg>
                    <!-- Layanan Pendukung icon (Customer Care / Headset) -->
                    <svg *ngIf="item.useSvg && item.svgType === 'layanan-pendukung'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="nav-icon-svg">
                        <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                        <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z" class="svg-yellow-fill" fill="currentColor"></path>
                        <path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" class="svg-yellow-fill" fill="currentColor"></path>
                    </svg>
                    <!-- Setting Pembagian Hasil icon (Percent / Revenue Share) -->
                    <svg *ngIf="item.useSvg && item.svgType === 'pembagian-hasil'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="nav-icon-svg">
                        <line x1="19" y1="5" x2="5" y2="19" class="svg-yellow-stroke" stroke-width="2.5"></line>
                        <circle cx="7" cy="7" r="3" class="svg-yellow-fill" fill="currentColor"></circle>
                        <circle cx="17" cy="17" r="3" class="svg-yellow-fill" fill="currentColor"></circle>
                    </svg>
                    <!-- Data Penghuni icon (from assets/images/kossaya/penghuni_ico.svg path) -->
                    <svg *ngIf="item.useSvg && item.svgType === 'data-penghuni'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="nav-icon-svg">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                        <circle cx="9" cy="7" r="4" class="svg-yellow-fill" fill="none"/>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" class="svg-yellow-stroke"/>
                    </svg>
                    <!-- Master Platform icon (Globe / Server Platform) -->
                    <svg *ngIf="item.useSvg && item.svgType === 'master-platform'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="nav-icon-svg">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="2" y1="12" x2="22" y2="12" class="svg-yellow-stroke"></line>
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                    </svg>
                    <!-- Default SVG (for missing ones) -->
                    <svg *ngIf="item.useSvg && !['settings', 'pelanggaran', 'pengaduan', 'iklan', 'fasilitas-umum', 'layanan-pendukung', 'data-penghuni', 'booking', 'pembagian-hasil', 'master-platform'].includes(item.svgType)"
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="nav-icon-svg">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="16"></line>
                        <line x1="8" y1="12" x2="16" y2="12"></line>
                    </svg>
                    </span>

                    <span class="nav-label">{{ item.label }}</span>
                    <svg *ngIf="item.children" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="nav-chevron" [class.rotated]="item.expanded">
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </a>

                <!-- Submenu -->
                <div class="submenu" *ngIf="item.children" [class.expanded]="item.expanded">
                    <a *ngFor="let child of getVisibleChildren(item)" class="nav-item child-item" [class.active]="isActive(child)"
                        (click)="navigateTo(child)">
                        <span class="nav-label">{{ child.label }}</span>
                    </a>
                </div>
                </div>
            </ng-container>
        </nav>

        <!-- Mobile footer: Profile + Logout -->
        <div class="sidebar-footer sidebar-footer-mobile">
            <a class="nav-item" (click)="navigateTo('/profile')">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="nav-icon-svg">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                </svg>
                <span class="nav-label">Manage Profil</span>
            </a>
            <a class="nav-item logout" (click)="logout()">
                <img class="nav-icon-img" src="assets/images/kossaya/logout_ico.png" alt="Keluar" />
                <span class="nav-label">Keluar</span>
            </a>
        </div>

        <!-- Collapse toggle (desktop only) -->
        <div class="sidebar-collapse-toggle" (click)="toggleCollapse()">
            <svg *ngIf="!sidebarCollapsed" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            <svg *ngIf="sidebarCollapsed" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
            <span class="nav-label">Collapse</span>
        </div>
    </aside>

    <!-- Sidebar overlay (mobile) -->
    <div class="sidebar-overlay" [class.visible]="sidebarOpen" (click)="toggleSidebar()"></div>

    <!-- ============ CONTENT ============ -->
    <main class="app-content">
        <div class="content-inner">
            <router-outlet></router-outlet>
        </div>
        <!-- ============ FOOTER ============ -->
        <footer class="app-footer">
            <span class="footer-text">
                © 2026 by <strong>AWH</strong>. Powered by <strong>PT. AWH Inti Nusantara</strong>. All Rights Reserved.
            </span>
        </footer>
    </main>
</div>